// extracted by mini-css-extract-plugin
module.exports = {"container":"TabletWidget-module--container--1mTUE","categories":"TabletWidget-module--categories--2VJLA"};